import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pharmaflow_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pharmaflow_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  seedAdmin: () => api.post('/seed-admin'),
};

// Clientes
export const clientesAPI = {
  getAll: () => api.get('/clientes'),
  getOne: (id) => api.get(`/clientes/${id}`),
  search: (q) => api.get(`/clientes/search?q=${encodeURIComponent(q)}`),
  create: (data) => api.post('/clientes', data),
  update: (id, data) => api.put(`/clientes/${id}`, data),
  delete: (id) => api.delete(`/clientes/${id}`),
};

// Produtos
export const produtosAPI = {
  getAll: () => api.get('/produtos'),
  getOne: (id) => api.get(`/produtos/${id}`),
  search: (q) => api.get(`/produtos/search?q=${encodeURIComponent(q)}`),
  create: (data) => api.post('/produtos', data),
  update: (id, data) => api.put(`/produtos/${id}`, data),
  delete: (id) => api.delete(`/produtos/${id}`),
};

// Receitas
export const receitasAPI = {
  getAll: () => api.get('/receitas'),
  getOne: (id) => api.get(`/receitas/${id}`),
  create: (data) => api.post('/receitas', data),
  update: (id, data) => api.put(`/receitas/${id}`, data),
  delete: (id) => api.delete(`/receitas/${id}`),
};

// Utilizadores
export const utilizadoresAPI = {
  getAll: () => api.get('/utilizadores'),
  getOne: (id) => api.get(`/utilizadores/${id}`),
  create: (data) => api.post('/utilizadores', data),
  update: (id, data) => api.put(`/utilizadores/${id}`, data),
  delete: (id) => api.delete(`/utilizadores/${id}`),
};

// Definicoes
export const definicoesAPI = {
  get: () => api.get('/definicoes'),
  update: (data) => api.put('/definicoes', data),
};

// Estatisticas
export const estatisticasAPI = {
  get: () => api.get('/estatisticas'),
};

// Mensagens (autenticado - médico)
export const mensagensAPI = {
  getByStatus: (lida) => api.get(`/mensagens?lida=${lida}`),
  countNovas: () => api.get('/mensagens/novas/count'),
  marcarLida: (id) => api.put(`/mensagens/${id}/lida`),
  delete: (id) => api.delete(`/mensagens/${id}`),
};

// Mensagens (público - rececionista)
const publicApi = axios.create({ baseURL: API_URL });
export const mensagensPublicAPI = {
  create: (data) => publicApi.post('/mensagens', data),
};

export const publicAPI = {
  getLogo: () => publicApi.get('/definicoes/logo'),
};

export default api;
